import { useMutation } from '@tanstack/react-query'

import type { UseMutationResult } from '@tanstack/react-query'
import type { ICreatePurchaseRequestBody } from '~/types/app-purchase'
import type { USER_TYPE } from '~/types/app-user'

import { createAppUserPurchase, deleteAppsUserPurchase, updateAppsUserPurchase } from '~/api/app-users'

////////// MUTATIONS //////////
export const useCreateAppUserPurchaseMutation = (): UseMutationResult<
  void,
  unknown,
  ICreatePurchaseRequestBody,
  unknown
> => useMutation({ mutationFn: createAppUserPurchase })

export const useUpdateAppsUserPurchaseMutation = (): UseMutationResult<
  void,
  unknown,
  { env: USER_TYPE; expirationDate: string; purchaseId: string; userId: string },
  unknown
> => useMutation({ mutationFn: updateAppsUserPurchase })

export const useDeleteAppsUserPurchaseMutation = (): UseMutationResult<
  void,
  unknown,
  { env: USER_TYPE; purchaseId: string; userId: string },
  unknown
> => useMutation({ mutationFn: deleteAppsUserPurchase })
